import { render, staticRenderFns } from "./ThanksBankCard.vue?vue&type=template&id=4b1371a8&scoped=true&"
import script from "./ThanksBankCard.vue?vue&type=script&lang=js&"
export * from "./ThanksBankCard.vue?vue&type=script&lang=js&"
import style0 from "./ThanksBankCard.vue?vue&type=style&index=0&id=4b1371a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1371a8",
  null
  
)

export default component.exports